import React from 'react';
import { GameCard } from './GameCard';
import { games } from './gameData';

export const GameSection: React.FC = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-[68px] tracking-tighter text-[#292B2D]">
        Educational Games
      </h2>
      
      <div className="grid grid-cols-4 gap-6 max-md:grid-cols-2 max-sm:grid-cols-1">
        {games.map((game, index) => (
          <GameCard key={index} game={game} index={index} />
        ))}
      </div>
    </div>
  );
};